export class SetHeightAction {

  constructor(
    public readonly height: number,
    public readonly wallScale: number
  ) {
  }

}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/actions/SetHeightAction.ts